<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable fullscreen>
      <v-form ref="OJTOrgWeightsForm" @submit.prevent>
        <v-card>
          <v-card-title
            class="d-flex align-center"
            style="background-color: #2196f3 !important; color: #ffffff"
          >
            <span>{{ name }}</span>
            <v-spacer></v-spacer>
            <v-btn
              icon="mdi-close"
              variant="text"
              color="white"
              @click="closeD()"
            >
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="">
            <v-container>
              <!-- <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="name"
                    :rules="[formRules.required]"
                    label="Organization Name"
                    :color="$vuetify.theme.themes.light.inputColor"
                    variant="outlined"
                    density="compact"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="email"
                    :rules="[formRules.required, formRules.email]"
                    label="Organization Email"
                    :color="$vuetify.theme.themes.light.inputColor"
                    variant="outlined"
                    density="compact"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="address"
                    :rules="[formRules.required]"
                    label="Address"
                    :color="$vuetify.theme.themes.light.inputColor"
                    variant="outlined"
                    density="compact"
                  ></v-textarea>
                </v-col>

                <v-col cols="12" v-if="action == 'Add'">
                  <v-autocomplete
                    density="compact"
                    label="Program/s Tied"
                    v-model="program_tied_id"
                    item-value="id"
                    item-title="name"
                    :color="$vuetify.theme.themes.light.inputColor"
                    variant="outlined"
                    multiple
                    clearable
                    chips
                    :items="programsList"
                  ></v-autocomplete>
                </v-col>
              </v-row> -->
              <v-row>
                <v-col cols="12">
                  <div
                    class="text-h6 my-8 pa-2 rounded-lg"
                    style="background: orange; color: white"
                  >
                    * Please take note that the total weights must equal to 100.
                    <br />
                    * Weight values are in percentage format.
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  :cols="this.$vuetify.display.smAndUp ? 4 : 12"
                  v-for="item in criterionList"
                  :key="item.id"
                >
                  <v-card
                    class="mx-auto my-4 rounded-md"
                    elevation="10"
                    max-width="500"
                  >
                    <v-card-item>
                      <v-card-title>{{ item.criterion.criteria }}</v-card-title>
                    </v-card-item>

                    <v-card-text>
                      {{ item.criterion.description }}
                    </v-card-text>
                    <v-card-text>
                      <div class="d-flex justify-space-between align-center">
                        <div class="font-weight-bold">Weight:</div>
                        <div>
                          <v-text-field
                            type="number"
                            v-model="item.weight"
                            @keyup="checkHasExceeded()"
                            :rules="[
                              formRules.required,
                              formRules.noDecimal,
                              !isExceeded,
                            ]"
                            :color="$vuetify.theme.themes.light.inputColor"
                            variant="outlined"
                            density="compact"
                          ></v-text-field>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-2 mr-4">
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="closeD()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn
              :color="$vuetify.theme.themes.light.submitBtns"
              class="white--text"
              density="comfortable"
              variant="flat"
              :disabled="btnLoading || !is100"
              :loading="btnLoading"
              @click="save()"
            >
              <v-icon>mdi-check-circle</v-icon>
              save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import eventBus from "@/eventBus";
export default {
  props: {
    data: Object,
    action: String,
  },
  data() {
    return {
      dialog: false,
      orgID: null,
      name: null,
      email: null,
      address: null,
      program_tied_id: null,
      btnLoading: false,
      criterionList: [],
      isExceeded: false,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;

        this.$refs.OJTOrgWeightsForm.resetValidation();
        if (data.id) {
          this.orgID = data.id;
          console.log(data);
          this.name = data.name;

          this.getCriterion(this.$store.state.user.program_id, this.data.id);
        }
      },
      deep: true,
    },
  },
  computed: {
    // hasExceededLimit() {
    //   let limit = 100;
    //   let total = 0;
    //   let hasExceeded = false;
    //   if (this.criterionList.length > 0) {
    //     for (let i = 0; i < this.criterionList.length; i++) {
    //       total += parseInt(this.criterionList[i].weight);
    //     }
    //     if (total > limit) {
    //       hasExceeded = true;
    //     } else {
    //       hasExceeded = false;
    //     }
    //   }
    //   return hasExceeded;
    // },
    is100() {
      let total = 0;
      for (let i = 0; i < this.criterionList.length; i++) {
        total += parseFloat(this.criterionList[i].weight);
      }
      return total == 100;
    },
  },
  methods: {
    initialize() {},

    setValue() {
      console.log("called");
      if (this.criterionList.length > 0) {
        let val = Math.floor(100 / this.criterionList.length);
        for (let i = 0; i < this.criterionList.length; i++) {
          if (this.criterionList[i].weight == null) {
            this.criterionList[i].weight = val;
          }
        }
      }
    },

    checkHasExceeded() {
      let limit = 100;
      let total = 0;

      if (this.criterionList.length > 0) {
        for (let i = 0; i < this.criterionList.length; i++) {
          total += parseInt(this.criterionList[i].weight);
        }

        if (total > limit) {
          this.isExceeded = true;
        } else {
          this.isExceeded = false;
        }
        setTimeout(async () => {
          await this.$refs.OJTOrgWeightsForm.validate();
        }, 100);
      }
    },

    async save() {
      let formValid = await this.$refs.OJTOrgWeightsForm.validate();

      if (formValid.valid) {
        this.btnLoading = true;
        if (this.is100) {
          let data = {
            org_id: this.orgID,
            criteriaWeights: JSON.stringify(this.criterionList),
            program_id: this.$store.state.user.program_id,
          };
          this.axiosCall("/org-criteria/setWeights", "POST", data).then(
            (res) => {
              if (res.data.status == 200) {
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "success";
                this.fadeAwayMessage.message = res.data.msg;
                this.fadeAwayMessage.header = "System Message";
                this.btnLoading = false;
                this.closeD();
              } else {
                this.btnLoading = false;
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "error";
                this.fadeAwayMessage.message = res.data.msg;
                this.fadeAwayMessage.header = "System Message";
              }
            }
          );
        } else {
          this.btnLoading = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.message =
            "Please distribute weights accordingly! ";
          this.fadeAwayMessage.header = "System Message";
        }
      }
    },

    closeD() {
      eventBus.emit("closeOrgCriteriaWeightsDialog", true);
      this.dialog = false;
    },

    getCriterion(programID, orgID) {
      this.axiosCall(
        "/org-criteria/getByProgram/" + programID + "/" + orgID,
        "GET"
      ).then((res) => {
        this.criterionList = res.data;
        this.setValue();
        // if (this.criterionList.length > 0) {
        //   let val = Math.floor(100 / this.criterionList.length);

        //   for (let i = 0; i < this.criterionList.length; i++) {
        //     this.criterionList[i].weight = val;
        //   }
        // }
        console.log("GET CRITERA", res.data);
      });
    },
  },
};
</script>
